<template>
  <div class="layout w-full h-full">
    <Layout class="h-full">
      <Sider ref="side1" hide-trigger collapsible :collapsed-width="78" v-model="isCollapsed">
        <div :class="logoClasses" style="height: 64px; border-bottom: 1px solid #505050">
          {{ currentTime }}
        </div>
        <Menu :active-name="activeName" theme="dark" width="auto" :class="menuitemClasses">
          <MenuItem name="home" to="/home">
            <Icon type="ios-home"></Icon>
            <span>首页</span>
          </MenuItem>
          <MenuItem name="in-sar" to="/in-sar">
            <Icon type="md-globe"></Icon>
            <span>InSAR</span>
          </MenuItem>
          <MenuItem name="time-seq" to="/time-seq">
            <Icon type="md-wifi"></Icon>
            <span>地面监测站</span>
          </MenuItem>
          <MenuItem name="history-data" to="/history-data">
            <Icon type="md-apps"></Icon>
            <span>历史数据</span>
          </MenuItem>
          <MenuItem name="warnning-data" to="/warnning-data">
            <Icon type="md-warning"></Icon>
            <span
              >预警通知
              <sup class="ivu-badge-count" v-if="warningNumber">{{ warningNumber }}</sup>
            </span>
          </MenuItem>
          <MenuItem name="warning-history" to="/warning-history">
            <Icon type="md-time"></Icon>
            <span>历史预警</span>
          </MenuItem>
        </Menu>
        <div class="logo-bar" :style="logoStyle">
          江苏中科星地空间技术有限公司
        </div>
      </Sider>
      <Layout>
        <Header :style="{ padding: 0 }" class="layout-header-bar">
          <Icon
            @click.native="collapsedSider"
            :class="rotateIcon"
            :style="{ margin: '0 20px' }"
            type="md-menu"
            size="18"
          ></Icon>
          <p class="inline-block text-xl font-semibold pl-3">
            {{ appTitle }}
          </p>
          <span class="inline-block absolute" :style="{ right: '2rem' }">
            <UserInfo></UserInfo>
          </span>
        </Header>
        <Content
          :style="{
            marginTop: '1px',
            background: '#fff',
            padding: '10px',
            minHeight: '260px'
          }"
        >
          <router-view />
        </Content>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import { listWaringMsg, listWaringMsg1 } from '@/api/warning';
import EventBus from '@/utils/event-bus';

export default {
  name: 'AppLayout',

  data() {
    return {
      warningNumber: 0,
      isCollapsed: false,
      currentTime: null,
      activeName: this.$route.path.split('/')[1]
    };
  },
  mounted() {
    this.getCurrentTime();
    EventBus.$on('setRead', () => {
      this.getWarning();
    });
    this.getWarning();
    setInterval(() => {
      this.getWarning();
    }, 60000);
  },
  computed: {
    isZJ() {
      return this.$appConfig.isZJ;
    },
    appTitle() {
      debugger;
      if (this.$appConfig.isZJ) {
        return this.$appConfig.TITLE1;
      }
      return this.$appConfig.TITLE;
    },
    rotateIcon() {
      return ['menu-icon', this.isCollapsed ? 'rotate-icon' : ''];
    },
    menuitemClasses() {
      return ['menu-item', this.isCollapsed ? 'collapsed-menu' : ''];
    },
    logoClasses() {
      return ['logo', this.isCollapsed ? 'collapsed-logo' : ''];
    },
    logoStyle() {
      // eslint-disable-next-line global-require
      const logoImage = require('@/assets/img/logo1.png');
      return {
        position: 'absolute',
        bottom: '10px',
        width: '100%',
        height: '30px',
        'background-size': 'contain',
        'background-repeat': 'no-repeat',
        backgroundImage: `url(${logoImage})`
      };
    }
  },
  watch: {
    $route() {
      const mainPath = this.$route.path.split('/')[1];
      this.activeName = mainPath;
    }
  },
  methods: {
    async getWarning() {
      if (this.isZJ) {
        const data = await listWaringMsg1();
        if (data && data.data && Array.isArray(data.data)) {
          const { length } = data.data.filter(item => !item.IsRead);
          this.warningNumber = length;
        }
      } else {
        const data = await listWaringMsg();
        if (data && data.data && Array.isArray(data.data)) {
          const { length } = data.data.filter(item => !item.IsRead);
          this.warningNumber = length;
        }
      }
    },
    format(date, fmt) {
      let dateString = fmt;
      const o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        dateString = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
      }
      Object.keys(o).forEach(k => {
        if (new RegExp(`(${k})`).test(dateString)) {
          dateString = dateString.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
          );
        }
      });

      return dateString;
    },

    getCurrentTime() {
      setInterval(() => {
        this.currentTime = this.format(new Date(), 'yyyy-MM-dd hh:mm:ss');
      }, 1000);
    },
    collapsedSider() {
      this.$refs.side1.toggleCollapse();
    }
  }
};
</script>
<style lang="scss" scoped>
.logo {
  height: 64px;
  border-bottom: 1px solid rgb(80, 80, 80);
  color: #fff;
  text-align: center;
  line-height: 64px;
  font-size: 16px;
  font-weight: bold;
  text-shadow: 0 0 5px rgba(255, 255, 255, 1);
}
.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.layout-logo-left {
  width: 90%;
  height: 30px;
  background: #5b6270;
  border-radius: 3px;
  margin: 15px auto;
}
.menu-icon {
  transition: all 0.3s;
}
.rotate-icon {
  transform: rotate(-90deg);
}
.menu-item span {
  display: inline-block;
  overflow: hidden;
  width: 89px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width 0.2s ease 0.2s;
}
.menu-item i {
  transform: translateX(0px);
  transition: font-size 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.collapsed-menu span {
  width: 0px;
  transition: width 0.2s ease;
}
.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
  vertical-align: middle;
  font-size: 22px;
}

::v-deep .ivu-badge-count {
  top: 10px;
  right: 80px;
  padding: 0;
  height: 15px;
  width: 15px;
  min-width: 15px;
  line-height: 15px;
}
::v-deep .ivu-layout-sider {
  width: 220px !important;
  min-width: 200px !important;
  max-width: 220px !important;
  flex: 0 0 220px !important;
}
.logo-bar {
  padding-left: 35px;
  line-height: 30px;
  font-size: 13px;
  font-weight: bold;
  color: #fff;
}
</style>
